export const INDEX = "/";
export const SIGNIN = "/sign-in";
export const SIGNOUT = "/sign-out";
export const DASHBOARD = "/dashboard";
